module.exports = __webpack_public_path__ + "img/logo.a287d4e3.png";